import { Box } from '@mui/material';
import { CenteredCircularProgress } from './CenteredCircularProgress';

export const Loader = () => (
  <Box height="100vh">
    <CenteredCircularProgress />
  </Box>
);
